// extracted by mini-css-extract-plugin
export var notificationHost = "_ko-0";